import type { FinalSong } from '../../interfaces/final-song';
import { usePlayerStore } from '../../stores/player-store';

// Start a playlist song in the mini-player.
//
// If the song is present in the results grid, play it right there in its inline
// tile (visible YouTube video / audio, exactly like clicking it in the grid) and
// scroll it into view - then flag it as playlist-sourced so the mini-player's
// next/back keep walking the playlist. Only when the song is NOT in the grid
// (nothing to render into) do we fall back to the Player-owned offscreen host /
// audio element via playSongFromPlaylist.
//
// This keeps navigation (playlist order) independent from where the video
// renders (the on-screen tile when available), so playlist playback is visible
// instead of hidden.
export function playPlaylistSong(song: FinalSong): void {
  const tile = song.youtube_id
    ? document.querySelector<HTMLElement>(`[data-result-item='${song.youtube_id}']`)
    : null;
  const playTarget = tile?.querySelector<HTMLElement>('[data-play-target]');

  if (playTarget) {
    // Reuse the grid tile's own play path (shows the video inline). That path
    // marks the song as results-sourced; re-flag it as playlist-sourced so
    // next/back stay on the playlist.
    playTarget.click();
    usePlayerStore.setState({ songPlayedFromPlaylist: true });
    tile?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }

  usePlayerStore.getState().playSongFromPlaylist(song);
}
